@if (fileForm) {
  <div
    [formGroup]="fileForm"
    class="wcg-upload-file-row grid grid-cols-2 gap-4"
    [ngClass]="!isLast() ? 'border-b-2' : ''"
    data-testid="upload-file-row"
  >
    <div
      data-testid="file-name"
      class="flex flex-col justify-between break-all"
    >
      <div class="wcg-upload-file-row__text" [matTooltip]="fileName">
        {{ fileName }}
      </div>
      <div class="wcg-upload-file-row__error-container">
        @if (file?.hasError("fileNameExceedsLimit")) {
          <wcg-error
            class="wcg-input__error"
            data-testid="file-name-length-error"
          >
            The file name exceeds 255 characters
          </wcg-error>
        }
        @if (file?.hasError("fileSizeExceedsLimit")) {
          <wcg-error class="wcg-input__error" data-testid="file-size-error">
            This file exceeds {{ maxFileSizeMb }} MB
          </wcg-error>
        }
        @if (file?.hasError("invalidFileType")) {
          <wcg-error class="wcg-input__error" data-testid="file-type-error">
            This is not a valid file type
          </wcg-error>
        }
      </div>
    </div>

    <div class="flex justify-between items-center">
      <div class="wcg-select compact" data-testid="file-type-select-container">
        <mat-form-field
          [class.error]="
            documentType?.invalid &&
            (documentType.dirty || documentType.touched)
          "
          appearance="outline"
          data-testid="file-type-form-field"
        >
          <mat-select
            matNativeControl
            formControlName="documentType"
            data-testid="file-type-select"
            placeholder="Select Document Type"
          >
            @for (documentType of documentTypes(); track documentType.name) {
              <mat-option
                [value]="documentType.name"
                data-testid="file-type-option"
              >
                {{ documentType.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (
          documentType?.invalid && (documentType.dirty || documentType.touched)
        ) {
          <wcg-error class="wcg-input__error" data-testid="document-type-error">
            Document type is required
          </wcg-error>
        }
      </div>
    </div>
  </div>
}
